export default __webpack_public_path__ + "static/media/icon_cat_BandsWithoutStones.b0c71994.png";